// inits the search bar on every page that is relevant

var F2Search = function() {};

F2Search.prototype.init = function() {
	this.appUrl = '~/F2/Apps/json?t=1'.resolveUrl();

	this.configHeader();
	this.initF2();

	return;
};

F2Search.prototype.configHeader = function() {
	this.headerConfig = [
		{
			appId: 'com_wfebrokerage_desktop_search', // app id, defined in EndPointConfigs/AppIds.cs
			context: {},
			enableBatchRequests: true,
			manifestUrl: this.appUrl,
			targetId: 'header-search', // target element id
			root: document.getElementById('header-search') // this tells F2 that the app is preloaded
		}
	];

	return;
};

F2Search.prototype.initF2 = function() {
	return F2.registerApps(this.headerConfig);
};
